import React from 'react';
import { IconMenu } from 'react-toolbox/lib/menu';
import styles from 'components/faceted-search/FacetMenu.css';

const FacetMenu = ({ children }) =>
  <IconMenu theme={styles} icon="filter_list" position="topRight" menuRipple>
    {children}
  </IconMenu>;

export default FacetMenu;
